import AppApi from './Api';
import axiosInstance from './AxiosInstance';

export const CustomerDashboardApi = AppApi.injectEndpoints({
  endpoints: (builder) => ({
    getCustomerRowOne: builder.query({
      queryFn: async ({ startDate, endDate }) => {
        try {
          const formData = new FormData();
          formData.append('startDate', startDate);
          formData.append('endDate', endDate);

          const response = await axiosInstance.post('/dashboard/customer_row_one', formData);
          return { data: response.data };
        } catch (error) {
          return { error: (error as any).response?.data || 'Something went wrong' };
        }
      },
      providesTags: ['CustomerDashboard'],
    }),

    getDisributionChart: builder.query({
      queryFn: async ({ startDate, endDate }) => {
        try {
          const formData = new FormData();
          formData.append('startDate', startDate);
          formData.append('endDate', endDate);

          const response = await axiosInstance.post('/dashboard/customer_ot_late', formData);
          return { data: response.data };
        } catch (error) {
          return { error: (error as any).response?.data || 'Something went wrong' };
        }
      },
      providesTags: ['CustomerDashboard'],
    }),

    getDeliveryByRegion: builder.query({
      queryFn: async ({ startDate, endDate }) => {
        try {
          const formData = new FormData();
          formData.append('startDate', startDate);
          formData.append('endDate', endDate);

          const response = await axiosInstance.post('/dashboard/customer_delivery_region', formData);
          return { data: response.data };
        } catch (error) {
          return { error: (error as any).response?.data || 'Something went wrong' };
        }
      },
      providesTags: ['CustomerDashboard'],
    }),
  }),
});

export const {
  useGetCustomerRowOneQuery,
  useGetDisributionChartQuery,
  useGetDeliveryByRegionQuery,
} = CustomerDashboardApi;
